import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router';
import type { NavItem } from '@/entities/session';
import { GLYPH } from '@/shared/ui';
import { findNavItem } from '../model/nav';
import { TopbarSearch } from './TopbarSearch';

export interface TopbarProps {
  nav: readonly NavItem[];
}

/**
 * Шапка (README §1): высота 54, фон белый, border-bottom line-hair, padding 0 28, gap 20.
 * Крошки «группа / раздел»: группа 12 ink-500 · «/» 12 ink-400 · раздел 13 500 ink-700.
 */
export function Topbar({ nav }: TopbarProps) {
  const { t } = useTranslation('shell');
  const match = useMatch('/:section/*');
  const item = findNavItem(nav, match?.params.section);
  return (
    <header className="flex h-54 shrink-0 items-center gap-20 border-b border-line-hair bg-paper-pure px-28">
      <nav aria-label={t('breadcrumbs')} className="flex min-w-0 items-center gap-10">
        {item ? (
          <>
            <span className="text-[12px] text-ink-500">{item.group}</span>
            <span aria-hidden="true" className="text-[12px] text-ink-400">
              {GLYPH.slash}
            </span>
            <span className="truncate text-[13px] font-medium text-ink-700">{item.label}</span>
          </>
        ) : (
          <span className="truncate text-[13px] font-medium text-ink-700">
            {t('section.unknownCrumb')}
          </span>
        )}
      </nav>
      <span className="flex-1" />
      <TopbarSearch />
    </header>
  );
}
